import React from "react";
import { useDispatch } from "react-redux";
import "../RoleName/RoleName.css";
import "../OptionBlocks.css";
import {
  NumberInput,
  Radio,
  Dropdown,
  Radio_nameonly,
  RadioNameonly,
} from "../../../../../Components";
import {
  ColumnVertical,
  ColumnHorizontal,
  AlphabeticalAtoZ,
  AlphabeticalZtoA,
  BalanceOff,
  BalanceCenter,
  Multiply,
  Bullet,
  Dimond,
  Pipeline,
  Square,
  None,
  SideAB,
  InsetOff,
  InsetLeft,
  InsetRight,
  SingleColumnRight,
  SingleColumnLeft,
  SingleColumnCenter,
  gutterJustify,
  spaceBetweenJustify,
  GutterAlignment,
  RightAlignment2,
  LeftAlignment2,
  RaggedAlignment,
} from "../../../../../assets/icons/index";
import {
  updateProjectCreditOptionsState,
  saveOptionById,
} from "../../../../../Redux/actions/projectActions";

import {
  Heading,
  Subheading,
} from "../../../../ProjectV2/Options/OptionFont/Functions";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const initialOptions = [
  { label: "None", value: 0 },
  { label: "10%", value: 10 },
  { label: "20%", value: 20 },
  { label: "30%", value: 30 },
  { label: "40%", value: 40 },
  { label: "50%", value: 50 },
];
const NameOnly = ({
  options,
  currentBlockIdx,
  currentBlockId,
  undoStack,
  isCard,
}) => {
  const dispatch = useDispatch();
  const [selectedID, setSelectedID] = useState("");
  const [option, setOptions] = useState([...initialOptions]);
  const location = useLocation();

  const handleChange = (key, value) => {
    switch (key) {
      case "columns":
        const new_columns = value;
        const new_column_width = Math.floor(100 / new_columns);
        dispatch(
          updateProjectCreditOptionsState(
            currentBlockIdx,
            "column_width",
            new_column_width,
          ),
        );
        dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, value));
        break;
      default:
        dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, value));
    }
  };

  useEffect(() => {
    const idx = option.findIndex(
      (opt) => opt.value === options?.margin_vertical,
    );
    if (idx !== -1) {
      setSelectedID(idx);
    }
  }, [options?.margin_vertical]);

  const saveOptions = () => {
    undoStack.push(options);
    dispatch(saveOptionById(currentBlockId, isCard));
  };

  const getValue = (value) => {
    return value ? value : "";
  };

  const conditionalColumnWidth = (val, options) => {
    const Max = 100 / options.columns;
    return parseInt(val > 0 ? (val < Max + 1 ? val : Max) : 0);
  };

  return (
    <div className="Roles-name">
      <div className="rolename-inside">
        <div className=" border-b-[1px] border-[#ffffff0e] pb-3 ">
          <div className="pt-[12px]">
            <div className="w-full font-body font-medium text-[13px] text-white ">
              Heading
            </div>
            <div className="w-full h-[46px] pt-1 rounded-2xl">
              <Heading
                onChange={(val) => {
                  handleChange("heading", val);
                }}
                value={getValue(options.heading)}
                onFocusOut={saveOptions}
              />
            </div>
          </div>

          <div className="pt-[12px]">
            <div className="w-full font-body font-medium text-[13px] text-white ">
              Sub-Heading
            </div>
            <div className="w-full h-[46px] pt-1 rounded-2xl">
              <Subheading
                onChange={(val) => {
                  handleChange("subheading", val);
                }}
                value={getValue(options.subheading ? options.subheading : "")}
                onFocusOut={saveOptions}
              />
            </div>
          </div>
        </div>
        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Text Alignment</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Adjust the visual spacing and dividing lines between roles and
              names.
            </span>
          </div>
          <div className="optionSectionContent">
            <RadioNameonly
              options={[
                {
                  icon: SingleColumnCenter,
                  value: "center",
                },
                {
                  icon: options.columns < 2 ? SingleColumnLeft : LeftAlignment2,
                  value: "left",
                },
                {
                  icon:
                    options.columns < 2 ? SingleColumnRight : RightAlignment2,
                  value: "right",
                },
                {
                  icon: gutterJustify,
                  value: options.columns < 2 ? "Right" : "gutter",
                  disabled: options.columns < 2,
                },
                {
                  icon: spaceBetweenJustify,
                  value: options.columns < 2 ? "Left" : "justify",
                  disabled: options.columns < 2,
                },
              ]}
              value={options.text_alignment}
              onChange={(val) => {
                handleChange("text_alignment", val);
                saveOptions();
              }}
              label={options.text_alignment}
              withIcon
            />
          </div>
        </div>
        <div className="optionSection h-14">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Arrangement</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Set the number of columns to arrange the credits in.
            </span>
          </div>
          <div className="optionSectionContent">
            <p className="radio-nameonly">
              <input
                type="radio"
                id="colomns"
                name="nameonlyArran"
                checked={options.bullets === null}
                onClick={() => {
                  handleChange("bullets", null);
                }}
                readOnly
              />
              <label for="colomns"> Column(s) </label>
            </p>
            <div className="colomn-s ml-[-57px]">
              <NumberInput
                postLabel=""
                value={options.columns}
                onChange={(val) => handleChange("columns", val)}
                min={1}
                max={5}
                onFocusOut={saveOptions}
                disabled={options.bullets !== null}
                customBtnMargin={{ marginLeft: "61px" }}
              />
            </div>
          </div>
        </div>
        <div className="optionSection h-7">
          <div className="flex items-center justify-end ">
            <p className="radio-nameonly">
              <input
                type="radio"
                id="paragraph"
                name="nameonlyArran"
                checked={options.bullets !== null}
                onClick={() => {
                  handleChange("bullets", "circle");
                }}
                readOnly
              />
              <label for="paragraph">Paragraph</label>
            </p>
            <div className="para-graph">
              <Radio
                options={[
                  { icon: Bullet, value: "circle" },
                  { icon: Square, value: "square" },
                  { icon: Dimond, value: "diamond" },
                  { icon: Pipeline, value: "lineVertical" },
                  { icon: Multiply, value: "cross" },
                ]}
                value={options.bullets}
                onChange={(val) => {
                  handleChange("bullets", val);
                  saveOptions();
                }}
                withIcon
                disabled={options.bullets === null}
              />
            </div>
          </div>
        </div>
        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">
              {options.bullets === null ? " Column width" : " Width"}
            </span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Adjust the horizontal width of the credit block as a percentage.
            </span>
          </div>

          <div className="optionSectionContent column-widthNameonly ">
            {options.bullets === null ? (
              <NumberInput
                postLabel="%"
                value={options.column_width}
                onChange={(val) =>
                  handleChange(
                    "column_width",
                    conditionalColumnWidth(val, options),
                  )
                }
                min={15}
                max={100}
                onFocusOut={saveOptions}
              />
            ) : (
              <NumberInput
                postLabel="%"
                value={options.column_width}
                onChange={(val) => handleChange("column_width", val)}
                min={20}
                max={100}
                onFocusOut={saveOptions}
              />
            )}
          </div>
        </div>

        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Balance</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Balance
            </span>
          </div>
          <div className="optionSectionContent ">
            <Radio
              options={[
                { icon: BalanceOff, value: null },
                { icon: BalanceCenter, value: "center" },
              ]}
              value={options.balance_columns}
              onChange={(val) => {
                handleChange("balance_columns", val);
                saveOptions();
              }}
              label={options.balance_columns === null ? "Off" : "Center"}
              withIcon
            />
          </div>
        </div>
        {!options?.bullets ? (
          <div className="optionSection">
            <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
              <span className="cursor-help">Ordering</span>
              <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
                Choose whether to display roles or names first..
              </span>
            </div>
            <div className="optionSectionContent">
              <Radio
                options={[
                  { icon: ColumnHorizontal, value: "horizontal" },
                  { icon: ColumnVertical, value: "vertical" },
                ]}
                value={options.column_flow}
                onChange={(val) => {
                  handleChange("column_flow", val);
                  saveOptions();
                }}
                label="Column flow"
                withIcon
              />
            </div>
          </div>
        ) : null}

        {!options?.bullets ? (
          <div className="optionSection">
            <div className="optionSectionContent2  cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
              <Radio
                options={[
                  { icon: None, value: null },
                  { icon: AlphabeticalAtoZ, value: "ascending" },
                  { icon: AlphabeticalZtoA, value: "descending" },
                ]}
                value={options.column_order}
                onChange={(val) => {
                  handleChange("column_order", val);
                  saveOptions();
                }}
                label="Alphabetical"
                withIcon
              />
            </div>
          </div>
        ) : null}

        {/* <hr className="border-2 border-[#e0e0e0]" /> */}
        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Block Inset</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Adjust the horizontal indentation and padding of the block.
            </span>
          </div>
          <div className="optionSectionContent BLock-inset-nameonly">
            <Radio
              label={options.block_inset}
              // options={[
              //   {
              //     icon: InsetOff, value: "default",
              //     disabled: (options?.side_by_side === "on" && (options?.block_inset === "default" || options?.block_inset === "left" || options?.block_inset === "right"))
              //   },
              //   { icon: InsetLeft, value: "left" },
              //   { icon: InsetRight, value: "right" },
              //   { icon: SideAB, value: "sidebyside", disabled: options?.side_by_side === "on" },
              // ]}
              options={[
                {
                  icon: InsetOff,
                  value: "default",
                  disabled:
                    options?.side_by_side === "on" &&
                    (options?.block_inset === "default" ||
                      options?.block_inset === "left" ||
                      options?.block_inset === "right"),
                },
                {
                  icon: InsetLeft,
                  value: "left",
                  disabled: options?.side_by_side === "on",
                },
                {
                  icon: InsetRight,
                  value: "right",
                  disabled: options?.side_by_side === "on",
                },
                {
                  icon: SideAB,
                  value: "sidebyside",
                  disabled: options?.side_by_side === "on",
                },
              ]}
              value={options.block_inset}
              onChange={(val) => {
                handleChange("block_inset", val);
                saveOptions();
              }}
              withIcon
            />
          </div>
        </div>
        {!isCard && (
          <div>
            <div className="optionSection">
              <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
                <span className="cursor-help">Margin</span>
                <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
                  Adjust the vertical margin around the credit block.
                </span>
              </div>
              <div className="optionSectionContent block-option-content">
                <div className="label-2 label-2-roleName1440">Vertical</div>
                <Dropdown
                  // label="Vertical"
                  options={option}
                  selectedID={selectedID}
                  value={options.margin_vertical}
                  onChange={(val) => {
                    handleChange("margin_vertical", val);
                    saveOptions();
                  }}
                />
              </div>
            </div>

            <div className="optionSection">
              <div className="optionSectionContent2 block-option-content">
                <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
                  <span className="cursor-help">Bottom</span>
                  <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
                    Adjust the extra spacing directly below the credit block.
                  </span>
                </div>
                <NumberInput
                  // label="Bottom"
                  value={options.extra_lines_below}
                  min={0}
                  max={25}
                  onChange={(val) => handleChange("extra_lines_below", val)}
                  onFocusOut={saveOptions}
                />
              </div>
            </div>
          </div>
        )}
        {isCard && <div></div>}
      </div>
    </div>
  );
};

export default NameOnly;
